import { DialogService, GridButton } from '@eforall/dashboard';
import { AccVentureDialogDataService } from '../../acc-venture-dialog-data.service';
import { AddEntrepreneurDialog } from '../add-entrepreneur/add-entrepreneur.dialog';


export function getButtons(dialogService: DialogService, dialogDataService: AccVentureDialogDataService): GridButton[] {

	const buttons: GridButton[] = [];

	const addEntBtn: GridButton = {
		iconClass: 'fa-plus',
		label: 'Add Entrepreneur',
		execute: async () => {
			const data = dialogDataService.dialogData();
			if (!data) return;

			await dialogService.showCustom(AddEntrepreneurDialog, { data: { accVentureId: data.accVentureId, ventureName: data.ventureName } }, 500, 400);
			await dialogDataService.reloadData();
		}
	};

	if (dialogDataService.canEdit()) {
		buttons.push(addEntBtn);
	}

	return buttons;
}